$(function () {
  if (!customElements.get('global-product-2')) {
    customElements.define(
      'global-product-2',
      class GlobalProduct2 extends HTMLElement {
        shopMoneyFormat = null;
        constructor() {
          super();
        }
        connectedCallback() {
          const _this = this;
          this.init();
          // 获取function_icon_wrapper
          const $functionIconWrapper = $(this).find('.function_icon_wrapper');
          const function_text_wrapper = $(this).find('.function_text_wrapper');
          const function_icon = $(this).find('.function_icon');

          const clearClickStatus = () => {
            this.mobileClickStatus = false;
            function_text_wrapper.css('opacity', 0).css('top', '0');
            $functionIconWrapper.each(function () {
              $(this).attr('data-click-status', 'false');
            });
            function_icon.removeClass('hover_icon');
          };
          $functionIconWrapper.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            // 判断屏幕宽度小于1200px
            if ($(window).width() <= 1200) {
              _this.mobileClickStatus = true;
              if ($(this).attr('data-click-status') === 'false') {
                function_text_wrapper.css('opacity', 0).css('top', '0');
                function_icon.removeClass('hover_icon');
                $functionIconWrapper.each(function () {
                  $(this).attr('data-click-status', 'false');
                });
                $(this).attr('data-click-status', 'true');
                $(this).find('.function_icon').addClass('hover_icon');
                $(this)
                  .find('.function_text_wrapper')
                  .addClass('block')
                  .removeClass('hidden')
                  .css('opacity', 1)
                  .css('top', '-12px');
              } else {
                clearClickStatus();
              }
            }
          });
          document.addEventListener('click', (e) => {
            if (this.mobileClickStatus) {
              clearClickStatus();
            }
          });
        }

        init() {
          const _this = this;
          const hoverWidth = $(this).find('.hover-width');
          hoverWidth.on('mouseenter', function () {
            if ($(this).find('.hover_text').is(':visible')) {
              $(this).css('width', 'auto');
              const autoWidth = $(this).width();
              $(this).css('width', '32px');
              setTimeout(() => {
                $(this).css('width', `${autoWidth}px`);
              }, 50);
            }
          });
          hoverWidth.on('mouseout', function () {
            if ($(this).find('.hover_text').is(':visible')) {
              setTimeout(() => {
                if (!$(this).is(':hover')) {
                  $(this).css('width', '32px');
                }
              }, 50);
            }
          });
          this.shopMoneyFormat = window.shopMoneyFormat;

          // 获取所有data-product-handle的元素
          const $productHandles = $(this).find('[data-product-handle]');

          $productHandles.on('click', function (event) {
            event.preventDefault();
            _this.openProductDetailModal(this);
          });

          const addCartButton = $(this).find('[data-first_variant_id]').find('[type="submit"]');
          addCartButton.on('click', function (event) {
            // 阻止默认事件
            event.preventDefault();
            // 获取index
            const index = $(_this).find('[data-first_variant_id]').find('[type="submit"]').index(this);
            const dataFirstVariantId = $(_this).find('[data-first_variant_id]').eq(index).data('first_variant_id');
            const skuCount = $(_this).find('[data-first_variant_id]').eq(index).data('sku-count');
            const inventoryPolicy = $(_this).find('[data-first_variant_id]').eq(index).data('inventory-policy');
            const view = $(_this).find('[data-first_variant_id]').eq(index).data('view');
            if (skuCount > 1) {
              // 找到最外层的swiper-slide
              const $globalProduct = $(this).closest('global-product-2');
              const $productHandle = $globalProduct.find('[data-product-handle]');
              _this.openProductDetailModal($productHandle[0], inventoryPolicy, view);
            } else {
              if (view === 'add_to_cart') {
                $(this).find('i').removeClass('hidden').addClass('flex');
                _this.addToCart(this, dataFirstVariantId, 1);
              }
            }
          });
        }

        openProductDetailModal(element, inventoryPolicy, view) {
          const _this = this;
          // 禁用浏览器滚动
          window.litime.disableScroll();
          window.litime.showLoading(false);
          const productHandle = $(element).data('product-handle');
          // 请求productHandle
          fetch(`/products/${productHandle}?view=modal`)
            .then((response) => {
              if (response.status === 200) {
                return response.text();
              } else {
                throw new Error('Network response was not ok');
              }
            })
            .then((responseText) => {
              const html = responseText;
              _this.renderProductDetailModal(html, inventoryPolicy, view, element);
            })
            .finally(() => {
              window.litime.hideLoading(false);
            });
        }

        renderProductDetailModal(html, inventoryPolicy, view, element) {
          const _this = this;
          const quickshopPopup = new DOMParser()
            .parseFromString(html, 'text/html')
            .getElementById('quickshop-popup')?.innerHTML;
          const $productDetailModal = $('#global-product-card-popup');
          $productDetailModal.html(quickshopPopup);
          try {
            const preferType = element && element.getAttribute('data-global-preferential-type');
            const popupEl = $productDetailModal.find('product-detail-data-popup')[0];
            console.log('popupEl', popupEl);
            console.log('preferType', preferType);
            if (popupEl && preferType) {
              popupEl.setAttribute('data-global-preferential-type', preferType);
            }

            if (popupEl && popupEl.applyPreferentialMode) {
              popupEl.applyPreferentialMode();
            }
          } catch (e) {
            console.warn('set preferential data failed:', e);
          }
          let modalWrapper = $productDetailModal.find('.product-detail-modal_wrapper');
          if (inventoryPolicy === 'continue' && view === 'buy_now_to_cart') {
            let $preOrderButton = modalWrapper
              .find('.product-detail-popup_button')
              .find('.buy-now-btn-card-button-popup');

            $preOrderButton.removeClass('hidden').addClass('flex');
            const $preOrderSubmitButton = modalWrapper
              .find('.product-detail-popup_form_wrapper')
              .find('.buy-now-btn-card-submit-button');
            $preOrderSubmitButton.addClass('hidden').removeClass('flex');
          } else {
            let $preOrderButton = modalWrapper
              .find('.product-detail-popup_form_wrapper')
              .find('.buy-now-btn-card-button-popup');
            $preOrderButton.addClass('hidden').removeClass('flex');
            const $preOrderSubmitButton = modalWrapper
              .find('.product-detail-popup_form_wrapper')
              .find('.buy-now-btn-card-submit-button');
            $preOrderSubmitButton.removeClass('hidden').addClass('flex');
          }
        }

        addToCart(event, productId, quantity) {
          const _this = this;

          $(event).find('.rotate_icon').removeClass('hidden').addClass('flex');
          $(event).find('.loading-button-text').addClass('hidden').removeClass('flex');
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              items: [
                {
                  id: productId,
                  quantity,
                },
              ],
              sections: 'cart-drawer,cart-icon-bubble',
            }),
          })
            .then((response) => response.json())
            .then((data) => {
              $(event).find('.rotate_icon').addClass('hidden').removeClass('flex');
              $(event).find('.loading-button-text').addClass('flex').removeClass('hidden');

              if (data.status && data.status != 200) {
                window.litime.showToast('error', data.message);
              } else {
                if (window.location.pathname === '/cart') {
                  window.location.reload();
                  window.scrollTo(0, 0);
                } else {
                  // 使用 updateCartComponents 更新购物车
                  updateCartComponents(data);
                  // 打开购物车抽屉
                  const cartDrawer = document.querySelector('cart-drawer');
                  if (cartDrawer) {
                    cartDrawer.open();
                  }
                }
              }
            })
            .catch((error) => {
              $(event).find('.rotate_icon').addClass('hidden').removeClass('flex');
              $(event).find('.loading-button-text').addClass('flex').removeClass('hidden');
            });
        }

        destroy() {
          // 恢复浏览器滚动
          window.litime.enableScroll();

          if (this.productDetailModalSmallPictrueSwiper) {
            this.productDetailModalSmallPictrueSwiper.destroy();
          }
          if (this.productDetailModalBigPictrueSwiper) {
            this.productDetailModalBigPictrueSwiper.destroy();
          }
        }

        disconnectedCallback() {
          this.destroy();
        }
      },
    );
  }
});
